import _ from "lodash"
import firebase from "gatsby-plugin-firebase"
import { toast } from "react-toastify"
import isBrowser from "../../utils/isBrowser"
import { startSetProfile, startSetHealthProfile } from "./profile"
// Login
export const login = () => {
  return dispatch => {
    firebase
      .auth()
      .signInWithPopup(new firebase.auth.GoogleAuthProvider())
      .then(res => {
        dispatch({
          type: "LOGIN",
          data: res.user,
        })
        typeof window !== "undefined" &&
          localStorage.setItem("auth", JSON.stringify(res.user))
      })
      .then(() => {
        dispatch(startSetProfile())
        dispatch(startSetHealthProfile())
        dispatch(checkAdmin())
      })
      .catch(e => {
        toast.error(e.message)
      })
  }
}

export const checkAdmin = () => {
  return (dispatch, getState) => {
    const uid = getState().auth.uid
    firebase
      .database()
      .ref(`users/${uid}/`)
      .once("value")
      .then(snapshot => {
        if (snapshot.val().isAdmin) {
          dispatch({
            type: "ADMIN_PROFILE",
          })
          isBrowser() && localStorage.setItem("admin", JSON.stringify(true))
        }
      })
      .catch(e => {
        console.log("Error: ", e)
      })
  }
}

// Logout
export const logout = () => {
  return dispatch => {
    firebase
      .auth()
      .signOut()
      .then(function () {
        dispatch({
          type: "SET_USER",
          data: undefined,
        })
        isBrowser() && localStorage.removeItem("auth")
        isBrowser() && localStorage.removeItem("profile")
        isBrowser() && localStorage.removeItem("healthProfile")
        isBrowser() && localStorage.removeItem("mealPlan")
        isBrowser() && localStorage.removeItem("progress")
        isBrowser() && localStorage.removeItem("workouts")
        isBrowser() && localStorage.removeItem("admin")
      })
      .catch(e => {
        console.log("Failed to logout", e)
      })
    dispatch({
      type: "LOGOUT",
    })
  }
}

// Add Medical History
